import { Link } from '@reach/router';
import React, { useContext } from 'react';
import { ButtonFilled } from '../../../components/ui';
import { NotebookContext } from '../../../context/NotebookContext';
import client from '../../../lib/client';
import redirect from '../../../lib/redirect';
import {
  GroupDeleteMutation,
  GroupDeleteMutationVariables
} from '../../../queries/__generated__/GroupDeleteMutation';
import { SelectedNotebookVariables } from '../../../queries/__generated__/SelectedNotebook';
import { groupDeleteMutation } from '../../../queries/groups';
import { selectedNotebookQuery } from '../../../queries/notebooks';

const GroupDelete: React.FC<{ groupId: string }> = ({ groupId }) => {
  const { notebook, reloadNotebook } = useContext(NotebookContext);

  async function deleteGroup() {
    await client.mutate<GroupDeleteMutation, GroupDeleteMutationVariables>({
      mutation: groupDeleteMutation,
      variables: { id: groupId },
      refetchQueries: [
        {
          query: selectedNotebookQuery,
          variables: { id: notebook.id } as SelectedNotebookVariables
        }
      ]
    });
    reloadNotebook();
    redirect('/notebook');
  }

  return (
    <div className="min-vh-100 flex flex-column items-center justify-center pa3">
      <div className="tc mw6">
        <p className="serif lh-copy measure-narrow mt0 mb4">
          You won&rsquo;t lose any data but are you sure you want to delete this group?
        </p>

        <ButtonFilled
          className="mb3"
          onClick={() => deleteGroup()}
          data-testid="confirm-delete-button"
        >
          Yes, Delete
        </ButtonFilled>
        <Link
          className="db f6 blue hover-navy"
          to={`/notebook/group/${groupId}/settings`}
          data-testid="cancel-delete-button"
        >
          No, Don’t Delete
        </Link>
      </div>
    </div>
  );
};

export default GroupDelete;
